/**
 * Authentication policy (plan §12) — frontend mirror of
 * backend/constants/authPolicy.js. Keep the two in sync.
 */
export const PASSWORD_MIN_LENGTH = 8;
export const OTP_LENGTH = 6;
export const OTP_RESEND_SECONDS = 30;
